"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdvanceParams = getAdvanceParams;
exports.getFromParams = getFromParams;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/web.dom-collections.for-each.js");
var ICE = {
  getValue: function getValue(o, k, d) {
    if (!k || !o) return d;
    try {
      k = k.split('.');
      var v = o[k[0]];
      for (var i = 1; i < k.length; i++) {
        v = v[k[i]];
      }
      if (typeof v == 'undefined') v = d;
      return v;
    } catch (e) {
      return d;
    }
  },
  trim: function trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, '');
  },
  isEmpty: function isEmpty(o) {
    if (o === '' || o === null || typeof o == 'undefined') return true;
    if (ICE.dataTypeOf(o) === 'array' && o.length === 0) return true;
    if (ICE.dataTypeOf(o) === 'object') {
      // eslint-disable-next-line no-unreachable-loop
      for (var k in o) {
        var _k$o;
        return (_k$o = k[o]) !== null && _k$o !== void 0 ? _k$o : false;
      }
      return true;
    }
    return false;
  },
  isNotEmpty: function isNotEmpty(o) {
    return !ICE.isEmpty(o);
  },
  dataTypeOf: function dataTypeOf(o) {
    var dataType = (0, _typeof2.default)(o) == 'object' ? Object.prototype.toString.call(o) : (0, _typeof2.default)(o);
    switch (dataType) {
      case '[object Array]':
        return 'array';
      case '[object Object]':
        return 'object';
      case '[object Date]':
        return 'date';
      default:
        return dataType;
    }
  },
  isArray: function isArray(x) {
    return ICE.dataTypeOf(x) === 'array';
  },
  isNum: function isNum(val) {
    if (val === '' || val === null) {
      return false;
    }
    if (val.length > 10) {
      return false;
    }
    if (!isNaN(val)) {
      val = (val + '').substr(0, 1);
      if (val === 0) {
        // 排查0开始的
        return false;
      }
      return true;
    }
    return false;
  }
};
var VARS = {
  // 表达式
  EXP_EQ: '=',
  EXP_NOT_EQ: '!=',
  EXP_GT: '>',
  EXP_LT: '<',
  EXP_GE: '>=',
  EXP_LE: '<=',
  EXP_IN: 'in',
  EXP_NOT_IN: 'notIn',
  EXP_LIKE: 'like',
  EXP_LEFT_LIKE: 'leftLike',
  EXP_RIGHT_LIKE: 'rightLike',
  EXP_IS_NULL: 'isNull',
  EXP_IS_NOT_NULL: 'isNotNull',
  // 排序方式：默认/自定义
  PARAM_CONDITION: 'conditions',
  STATIC_CONDITIONS: 'staticConditions',
  ORDER_DEFAULT: 'default',
  ASC: 'ASC',
  DESC: 'DESC'
};
function getFromParams(params) {
  var queryParams = params.queryParams;
  var fieldsMapping = params.fieldsMapping;
  var queryList = [];
  for (var k in queryParams) {
    var name = k;
    var value = queryParams[k];
    if (fieldsMapping[name] && value) {
      queryList.push((0, _objectSpread2.default)({
        code: name,
        value: value
      }, fieldsMapping[name]));
    }
  }
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, queryParams), getAdvanceParams(queryList));
}

// 查询条件组装
function getAdvanceParams(list, defaultQueryValue) {
  var _list$filter, _list$filter2, _list$filter3;
  var returnParams = {};
  var queryList = (_list$filter = list.filter(function (item) {
    return item.type !== 'static';
  })) !== null && _list$filter !== void 0 ? _list$filter : [];
  var staticList = (_list$filter2 = list.filter(function (item) {
    return item.type === 'static';
  })) !== null && _list$filter2 !== void 0 ? _list$filter2 : [];
  var defaultList = (_list$filter3 = list.filter(function (item) {
    return item.defaultValue;
  })) !== null && _list$filter3 !== void 0 ? _list$filter3 : [];
  returnParams.conditionLink = 'AND';
  if (defaultQueryValue || defaultList.length > 0) {
    returnParams.conditionLink = 'OR';
  }
  queryList.forEach(function (item) {
    if (item.default && defaultQueryValue) {
      item.value = defaultQueryValue;
    } else if (defaultQueryValue) {
      item.value = '';
    }
  });
  returnParams[VARS.PARAM_CONDITION] = getCondition(queryList);
  returnParams[VARS.STATIC_CONDITIONS] = getCondition(staticList);
  return returnParams;
}
function getCondition(queryList) {
  var conditionList = [];
  queryList.forEach(function (obj) {
    var name = obj.code;
    var value = obj.value;
    if (ICE.isNotEmpty(value)) {
      var exp = '';
      var sp = '';
      var valArr = [];
      var isNum = typeof value !== 'string' && (ICE.getValue(obj, 'dataType') === 'number' || ICE.isNum(value));
      if (!isNum) {
        if (ICE.isArray(value)) {
          valArr = value;
        } else {
          if (value instanceof Function) {
            value = value();
          }
          sp = ICE.getValue(obj, 'multiSeparator', ',');
          if (sp) {
            valArr = value.split(sp);
          } else {
            valArr.push(value);
          }
          value = ICE.trim(value);
        }
      }
      if (!exp) {
        exp = ICE.getValue(obj, 'sqlExp', 'like');
        exp = Array.isArray(exp) ? exp[0] : exp;
      }
      var cc = name.replace(/[A-Z]/g, function (s) {
        return '_' + s;
      }).replace(/^\_/, '').toUpperCase();
      var column = ICE.getValue(obj, 'dbColumn', cc);
      if (exp === VARS.EXP_IN || exp === VARS.EXP_NOT_IN) {
        if (isNum) {
          for (var i = 0; i < valArr.length; i++) {
            valArr[i] = parseFloat(valArr[i]);
          }
        }
        conditionList.push({
          column: obj.keep ? name : column,
          exp: exp,
          value: obj.keep ? value : valArr
        });
      } else {
        var c = {
          column: column,
          exp: exp
        };
        if (ICE.isNotEmpty(value)) c.value = isNum ? parseFloat(value) : value;
        if (c.column) {
          conditionList.push(c);
        }
      }
    }
  });
  return conditionList;
}